import * as SurveyConfig from '../../services/api/typeSurveyConfig'

import { useApiRequest } from '../useApiRequest'

export function useGetTypeSurveyConfig (sociogramId) {
  const { data, loading, error } = useApiRequest(SurveyConfig.fetchAll(sociogramId))
  return { data, loading, error }
}
